var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 23.2517C5.88975 23.2517 5.77875 23.227 5.6745 23.1775C5.41575 23.0522 5.25 22.7905 5.25 22.5017V18.7517H3C1.7595 18.7517 0.75 17.7422 0.75 16.5017V4.50171C0.75 3.26121 1.7595 2.25171 3 2.25171H21C22.2405 2.25171 23.25 3.26121 23.25 4.50171V16.5017C23.25 17.7422 22.2405 18.7517 21 18.7517H11.8883L6.46875 23.0875C6.333 23.1962 6.16725 23.2517 6 23.2517ZM3 3.75171C2.586 3.75171 2.25 4.08846 2.25 4.50171V16.5017C2.25 16.915 2.586 17.2517 3 17.2517H6C6.41475 17.2517 6.75 17.587 6.75 18.0017V20.9417L11.1562 17.416C11.2898 17.3095 11.454 17.2517 11.625 17.2517H21C21.414 17.2517 21.75 16.915 21.75 16.5017V4.50171C21.75 4.08846 21.414 3.75171 21 3.75171H3Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.75171H6C5.58525 9.75171 5.25 9.41571 5.25 9.00171C5.25 8.58771 5.58525 8.25171 6 8.25171H18C18.4148 8.25171 18.75 8.58771 18.75 9.00171C18.75 9.41571 18.4148 9.75171 18 9.75171Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.7517H6C5.58525 12.7517 5.25 12.4157 5.25 12.0017C5.25 11.5877 5.58525 11.2517 6 11.2517H12C12.4148 11.2517 12.75 11.5877 12.75 12.0017C12.75 12.4157 12.4148 12.7517 12 12.7517Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.227ad9f1b25ae9f77edd91d3dc5a44fe.svg";
export { ForwardRef as ReactComponent };